/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { NotificationCommentReplyNotificationAsJSON } from './NotificationCommentReplyNotificationAsJSON';
import { NotificationGeneralFeedbackReplyNotificationAsJSON } from './NotificationGeneralFeedbackReplyNotificationAsJSON';
const NotificationParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['comment_notification', NotificationCommentReplyNotificationAsJSON],
    ['general_comment_notification', NotificationGeneralFeedbackReplyNotificationAsJSON],
]);
export const Notification = NotificationParser;
